var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86,
    height: 79,
    viewBox: "0 0 86 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-iPhone_14_Pro_Max_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 79
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPhone_14_Pro_Max_1",
    "data-name": "iPhone 14 Pro Max \\u2013 1",
    clipPath: "url(#clip-iPhone_14_Pro_Max_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5466",
    "data-name": "Path 5466",
    d: "M1,71.226H81.157L41.078,2ZM44.722,60.3H37.435V53.009h7.287Zm0-14.574H37.435V31.148h7.287Z",
    transform: "translate(1.422 2.887)",
    fill: "#eb1616"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/Error_Icon.5d15bf7398662282f4a5d0af82e13ea4.svg";
export { ForwardRef as ReactComponent };